import { render, staticRenderFns } from "./TemplatingTaskCard.vue?vue&type=template&id=4bcf758c&scoped=true"
import script from "./TemplatingTaskCard.vue?vue&type=script&lang=js"
export * from "./TemplatingTaskCard.vue?vue&type=script&lang=js"
import style0 from "./TemplatingTaskCard.vue?vue&type=style&index=0&id=4bcf758c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4bcf758c",
  null
  
)

export default component.exports